import { VISIT_PIC_APP } from './constants/policies'

export default {
  name: 'PIC',
  prefix: 'pic',
  shortName: 'PIC',
  icon: 'fas fa-database',
  description: 'Product Information Center.',
  policy: VISIT_PIC_APP,
  ns: 'PIC',
  document: 'https://docs.google.com/document/d/1zvvtBtIq54cbgB_1LtaBy5cu5RkfcA51wPVS9bxe2_Y/edit?usp=sharing',
  isMoveToNewSite: false
}
